import type { MessageKey } from "./en";

// Stub Bulgarian translations. Replace `[BG] ...` strings with real copy.
export const bg: Record<MessageKey, string> = {
  "nav.platform": "Платформа",
  "nav.services": "Услуги",
  "nav.useCases": "Приложения",
  "nav.resources": "Ресурси",
  "nav.pricing": "Ценоразпис",
  "nav.insights": "Анализи",
  "nav.login": "Вход",
  "nav.mediaMonitoring": "Медиен мониторинг",
  "nav.mediaAnalysis": "Медиа анализ",
  "nav.whoWeHelp": "За кого работим",
  "nav.industries": "Индустрии",
  "nav.company": "Компания",
  "cta.requestDemo": "Заявете демо",
  "footer.col.platform": "Платформа",
  "footer.col.services": "Услуги",
  "footer.col.resources": "Ресурси",
  "footer.col.company": "Компания",
  "footer.tagline": "Медийно разузнаване за комуникационни и маркетинг екипи в цяла Европа.",
  "footer.hq.value": "София, България",
  "footer.copyright": "© Perceptica. Всички права запазени. 2012-2026.",
  "footer.link.requestDemo": "Заявете демо",
  "footer.link.mlp": "Платформа за медиен мониторинг",
  "footer.link.coverage": "Покритие",
  "footer.link.pricing": "Ценоразпис",
  "footer.link.faq": "Често задавани въпроси",
  "footer.link.mediaAnalysis": "Медиен анализ",
  "footer.link.reputation": "Анализ на репутацията",
  "footer.link.competitive": "Анализ на конкуренцията",
  "footer.link.crisis": "Кризисен мониторинг и анализ",
  "footer.link.market": "Анализ на пазара",
  "footer.link.employer": "Анализ на работодателска организация",
  "footer.link.blog": "Блог",
  "footer.link.reports": "Доклади",
  "footer.link.whoWeHelp": "За кого работим",
  "footer.link.whyPerceptica": "Защо Perceptica",
  "footer.link.about": "За нас",
  "footer.link.careers": "Кариери",
  "footer.link.contact": "Контакти",
  "footer.link.partners": "Партньори и медии",
  "footer.link.privacy": "Политика за поверителност",
  "footer.link.cookies": "Политика за бисквитки",
  "locale.switchTo.bg": "БГ",
  "locale.switchTo.en": "EN",
  "cookie.title": "Вашата поверителност",
  "cookie.bodyBefore": "Използваме основни бисквитки, за да работи този сайт. С вашето съгласие може да използваме и аналитични и маркетингови бисквитки, за да разбираме как се използва сайтът и да подобряваме вашето изживяване. Вижте нашата ",
  "cookie.bodyLink": "политика за бисквитки",
  "cookie.bodyAfter": ".",
  "cookie.acceptAll": "Приемам всички",
  "cookie.rejectNonEssential": "Откажи неесенциалните",
  "cookie.manage": "Управление",
  "cookie.savePreferences": "Запази предпочитанията",
  "cookie.close": "Затвори",
  "cookie.cat.necessary": "Строго необходими",
  "cookie.cat.necessaryDesc": "Нужни са, за да работи сайтът. Винаги активни.",
  "cookie.cat.analytics": "Аналитични",
  "cookie.cat.analyticsDesc": "Google Analytics - помага ни да разберем как се използва сайтът.",
  "cookie.cat.marketing": "Маркетингови",
  "cookie.cat.marketingDesc": "HubSpot и LinkedIn - измерване на кампании и показване на релевантно съдържание.",
  "footer.cookieSettings": "Настройки за бисквитки",
};